import React from "react";
import Editor from "./Editor";
import { Spinner } from "../Spinner";

// Shared state to prevent duplicate remove background calls across component remounts
let removeBackgroundInProgress = false;
let removeBackgroundPromise = null;

export default class CanvasSvg extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        };
    }

    componentDidMount() {
        if (this.el) {
            this.node = document.createElement("div");
            this.el.appendChild(this.node);

            this.editor = new Editor({
                target: this.node,
                image: this.props.image,
                svgData: this.props.svgData,
                svgUrl: `https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/${this.props.image}/sm`,
                removeBackgroundOnInit: this.props.removeBackgroundOnInit,
                onColorChanged: this.props.onColorChanged,
                onLoginNeeded: this.props.onLoginNeeded,
                onPremiumNeeded: this.props.onPremiumNeeded,
                onError: this.props.onError,
                onLoading: (isLoading) => {
                    this.props.onLoading({ loading: isLoading });
                },
                doneInit: () => {
                    this.setState({
                        loading: false,
                    });
                    this.props.onDoneInit();
                },
                checkRemoveBackgroundInProgress: () => {
                    if (removeBackgroundInProgress && removeBackgroundPromise) {
                        return removeBackgroundPromise;
                    }
                    return null;
                },
                setRemoveBackgroundInProgress: (inProgress, promise = null) => {
                    removeBackgroundInProgress = inProgress;
                    removeBackgroundPromise = promise;
                },
            });

            this.props?.onEditorReady?.(this.editor);
        }
    }

    componentDidUpdate(prevProps) {

        console.log(this.editor)
        if (prevProps.brushSize !== this.props.brushSize) {
            this.editor.setBrushSize(this.props.brushSize);
        }
        if (prevProps.brushColor !== this.props.brushColor) {
            this.editor.setBrushColor(this.props.brushColor);
        }
        if (prevProps.mode !== this.props.mode) {
            this.editor.setMode(this.props.mode);
        }
    }

    componentWillUnmount() {
        this.node.remove();
        if (this.editor) {
            this.editor.onColorChanged = null;
            this.editor = null;
        }
    }

    render() {
        return (
            <div
                className={this.props.className}
                key="svg-wrapper"
                ref={(el) => (this.el = el)}
            >
                {this.state.loading ? (
                    <div className="w-full flex justify-center align-middle items-center">
                        <div className="self-center flex items-center justify-center" style={{ width: 512, height: 512 }}>
                            <Spinner className="w-16 h-16" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}
